import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

const propTypes = {
  hasError: PropTypes.bool,
}

function ScheduleSubmitSection(props) {
  const { hasError = false } = props ?? {}

  if (hasError) {
    return (
      <div>
        <span className="font-color-danger fas fa-circle-xmark me-2" />
        <span className="text-bold">
          <FormattedMessage id="ENGAGE.SCHEDULING.SCHEDULING_FAILED" />
        </span>
      </div>
    )
  }

  return (
    <div>
      <span className="font-color-engage fas fa-circle-check me-2" />
      <span className="text-bold">
        <FormattedMessage id="ENGAGE.SCHEDULING.SCHEDULING_SUCCEEDED" />
      </span>
    </div>
  )
}

ScheduleSubmitSection.propTypes = propTypes

export default ScheduleSubmitSection
